import type { SessionStatus } from "./types";
import type { SortOption } from "./WorkflowSessionsTable";

/** Status filter pill definitions */
export const STATUS_PILLS: { label: string; value: string; style: string }[] = [
  { label: "All", value: "all", style: "pillAll" },
  { label: "Active", value: "active", style: "pillActive" },
  { label: "Completed", value: "completed", style: "pillCompleted" },
  { label: "Archived", value: "archived", style: "pillArchived" },
  { label: "Cancelled", value: "cancelled", style: "pillCancelled" },
];

/** Sort option definitions */
export const SORT_OPTIONS: { label: string; value: SortOption }[] = [
  { label: "Recent", value: "recent" },
  { label: "Oldest", value: "oldest" },
  { label: "Priority", value: "priority" },
];

/** Map pill filter value to the actual statuses it represents */
export const getStatusesForFilter = (filter: string): SessionStatus[] | undefined => {
  switch (filter) {
    case "active":
      return ["active"];
    case "completed":
      return ["completed"];
    case "archived":
      return ["archived"];
    case "cancelled":
      return ["cancelled"];
    default:
      return undefined;
  }
};
